import { ref, watch, computed, type ComputedRef, type Ref } from "vue";

export function useProlonged(source: Ref<boolean> | ComputedRef<boolean>, delay: number) {
  const state = ref(false);
  let timer: ReturnType<typeof setTimeout> | null = null;

  watch(
    source,
    (val) => {
      if (val) {
        // source became true → show immediately
        state.value = true;
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
      } else {
        // source became false → wait before hiding
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
          state.value = false;
          timer = null;
        }, delay);
      }
    },
    { immediate: true },
  );

  return computed(() => state.value);
}
